export default "__VITE_ASSET__e11e9f7f__"